<template>
  <div class="select-search"  style="position: relative;">
    <div :class="hasIcon(icon) || hasCustomSlot">
       <!-- Left icon -->
      <!-- <span v-if="props.iconDir === 'left'" class="input-group-text">
        <slot name="icon">
            <i :class="getIcon(props.icon)" v-if="props.icon"></i>
        </slot>
    </span> -->

      <span v-if="icon && iconDir === 'left'" class="input-group-text">
        <img :src="icon" class="icon-img" alt="icon" />
      </span>

      <!-- Input -->
    <input
      type="text"
      :placeholder="placeholder"
      v-model="searchTerm"
      :disabled="disabled"
      @input="onInput"
      class="form-control"
      :class="[sizeClass, successClass, errorClass]"
      @focus="onFocus"
    />

    <ul v-if="showDropdown" class="my-dropdown-menu" :class="{ show: showDropdown }">
      <li
        v-for="item in options"
        :key="item[idKey]"
        @click="selectOption(item)"
        class="dropdown-item"
        :class="[getClasses(size, success, error), $attrs.class]"
      >
        {{ item[labelKey] }}
      </li>
      <li v-if="loading" class="dropdown-item text-muted">Loading...</li>
      <li v-if="!loading && options.length === 0" class="dropdown-item text-muted">No results found</li>
    </ul>
  </div>
  </div>
</template>

<script setup>
import { ref, watch, computed, onMounted, onUnmounted } from 'vue';
import { debounce } from 'lodash-es';
import { useSlots } from 'vue';
const slots = useSlots();
const hasCustomSlot = !!slots.icon;
// เพิ่มตรงบนสุด
const isValidInput = ref(true);



const props = defineProps({
  modelValue: [String, Number, Object],
  placeholder: { type: String, default: 'Search...' },
  disabled: { type: Boolean, default: false },
  size: { type: String, default: 'default' },
  success: { type: Boolean, default: false },
  error: { type: Boolean, default: false },

  idKey: { type: String, default: 'id' },
  labelKey: { type: String, default: 'name_en' },
  fetchFunc: { type: Function, required: false },
  icon: { type: String, default: '' },      // เพิ่ม icon
  iconDir: { type: String, default: 'left' } // เพิ่ม iconDir
});

//const emit = defineEmits(['update:modelValue']);
const emit = defineEmits(['update:modelValue', 'validity']);

const searchTerm = ref('');
const options = ref([]);
const loading = ref(false);
const showDropdown = ref(false);

watch(searchTerm, (newTerm) => {
  // เช็คว่าคำที่พิมพ์ตรงกับ options ใดไหม (โดยใช้ labelKey)
  const matched = options.value.some(
    (item) => item[props.labelKey].toLowerCase() === newTerm.toLowerCase()
  );
  isValidInput.value = matched || newTerm === '';

  // emit validity status
  emit('validity', isValidInput.value);
});

const sizeClass = computed(() => {
  return props.size === 'small'
    ? 'form-control-sm'
    : props.size === 'large'
    ? 'form-control-lg'
    : '';
});
const successClass = computed(() => (props.success ? 'is-valid' : ''));
const errorClass = computed(() => (props.error ? 'is-invalid' : ''));

async function fetchOptions(query) {
  if (!query || !props.fetchFunc) {
    options.value = [];
    showDropdown.value = false;
    return;
  }

  loading.value = true;
  try {
    const data = await props.fetchFunc(query);
    console.log('Options:', data);

    options.value = Array.isArray(data) ? data : [];

    if (options.value.length > 0) {
      showDropdown.value = true;
    } else {
      showDropdown.value = false;
    }

    console.log('showDropdown:', showDropdown.value, 'options length:', options.value.length);

  } catch (e) {
    options.value = [];
    showDropdown.value = false;
    console.error('Error fetching options:', e);
  } finally {
    loading.value = false;
  }
}

const debouncedFetch = debounce(fetchOptions, 300);

// function onInput() {
//   if (props.disabled) return;

//  // console.log('onInput:', searchTerm.value);
//   debouncedFetch(searchTerm.value);
//   // showDropdown.value = true;  // ลบออกเพื่อให้ fetchOptions เป็นตัวกำหนด
// }

function onInput() {
  if (props.disabled) return;

  if (!searchTerm.value) {
    // ถ้าลบหมดแล้ว ให้ reset v-model เป็น null
    emit('update:modelValue', null);
    showDropdown.value = false;
    options.value = [];
    return;
  }

  debouncedFetch(searchTerm.value);
}


function selectOption(option) {
  emit('update:modelValue', option);
  searchTerm.value = option[props.labelKey];
  showDropdown.value = false;
}

function onFocus() {
  if (options.value.length > 0) {
    showDropdown.value = true;
  }
}


const getClasses = (size, success, error) => {
  let sizeValue = size ? `form-control-${size}` : null;
  let isValidValue = error ? "is-invalid" : success ? "is-valid" : "";
  return `${sizeValue} ${isValidValue}`;
};

//const getIcon = (icon) => (icon ? icon : null);
const hasIcon = (icon) => (icon ? "input-group" : null);

watch(
  () => props.modelValue,
  (val) => {
    if (val && typeof val === 'object') {
      searchTerm.value = val[props.labelKey] || '';
    } else {
      searchTerm.value = val || '';
    }
  },
  { immediate: true }
);

function handleClickOutside(e) {
  const el = document.querySelector('.select-search');
  if (el && !el.contains(e.target)) {
    showDropdown.value = false;
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside);
});

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside);
});
</script>


<style scoped>
.my-dropdown-menu {
  position: absolute; /* ทำให้ dropdown อยู่เหนือ layout ปกติ */
  top: 100%;          /* อยู่ใต้ input */
  left: 0;
  right: 0;
  z-index: 1000;      /* อยู่บน element อื่น */
  max-height: 200px;
  overflow-y: auto;
  display: none;      /* ซ่อนก่อน */
  background: #fff;
  border: 1px solid #ffffff0a;
  border-radius: 4px;
}

.my-dropdown-menu.show {
  display: block;     
  margin-top: 5px;
  font-size: 14px;
  box-shadow: 0 4px 6px rgba(157, 157, 157, 0.7);
  background-color: rgba(233, 238, 245, 1);
  color: rgba(38, 51, 77, 1);
}


.is-invalid {
  border: 1px solid #dc3545 !important;
  box-shadow: 0 0 0 0.1rem rgba(220, 53, 69, 0.25);
}

.is-valid {
  border: 1px solid #28a745;
  box-shadow: 0 0 0 0.1rem rgba(40, 167, 69, 0.25);
}

.icon-img {
  width: 15px;
  height: 15px;
  display: inline-block;
}

</style>
